import styled from 'styled-components';
import { fontSize_SM, fontSize_XS } from '../../customFonts';

export const EmptyStateWrapper = styled.div`
    width: 100%;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding: 30px 0;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    h5 {
        color: #374151;
        ${fontSize_SM};
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        margin-top: 10px;
        margin-bottom: 2px;
    }

    p {
        color: #687080;
        text-align: center;
        ${fontSize_XS};
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 0;
    }
`;
